/*
dilip  10/10/2022 3075154998  changed Visibility To Datausage icon
dilip  10/10/2022 3075154998  visbility icon changed to Datausage
Raghu  26/10/2022   3075154998   Table Alignments and Enhancements
akhila    10/28/2022 3075154998 enable framework UX changes
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
akhila 11/01/2022 3075154998 TablePagination bugFix
Suresh Peddavoora 11/03/2022 3075154998 Table Pagination Tab Responsive Fixes

*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {
  fetchMediaType,
  fetchMediaTypeUsage,
  printMediaType,
  resetMessage,
  fetchError,
  fetchSuccess,
} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DataUsageOutlinedIcon from '@material-ui/icons/DataUsageOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {makeStyles} from '@material-ui/core';
import {resetStatus} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
import PageLoader from '../../../../../components/PageLoader';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import OverrideRule from '../../../../../components/OverrideRule';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';

const useStyles = makeStyles((theme) => ({
  searchText: {
    fontWeight: '900',
    color: '#000000',
    fontSize: '16px',
    marginBottom: '0',
  },
}));

export default function MediaTypeSearchTable({
  setTabValue,
  searchData,
  setSearchData,
  setCode,
  handleClose,
  mediaName,
  setMediaName,
  setSelectedMediaTypeName,
  submit,
  setSubmit,
  setIsCopyData,
  disableCopy,
  setUsageState,
  usageState,
  setUsage,
  setDeleteUsage,
  userMetrixDelete,
  isDelete,
  setIsDelete,
  isUsage,
  setIsUsage,
}) {
  // const [message, setMessage] = useState('');
  const message = '';
  useEffect(() => {
    usageState && setUsageState(false);
  }, []);

  const columns = [
    {
      title: 'Media Type',
      field: 'name',
    },
    {
      title: 'Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.description}
          </div>
        </>
      ),
    },
  ];
  const classes = useStyles();
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [status, setStatus] = useState(false);
  const [deleteWindowData, setDeleteWindow] = useState('');


  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  const {isLoading, successMsg, errorMsg, usageMedial, mediaTypePrintStatus} = useSelector(({addMediaType}) => addMediaType);
  useEffect(() => {
    dispatch(resetStatus());
    if (setCode) {
      setMediaName('');
      setCode(null);
    }
  }, []);

  useEffect(() => {
    if (mediaTypePrintStatus && mediaTypePrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [mediaTypePrintStatus]);

  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  const handleDelete = (rowData) => {
    setUsage(false);
    setDeleteUsage(true);
    setDeleteWindow(rowData);
    dispatch(fetchMediaTypeUsage(rowData.name));
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };

  const handleDeleteSubmission = () => {
    new Promise((resolve, reject) => {
      httpPaginationDelete(`enableintegration/delete/mediatype/${deleteWindowData?.id}`)
        .then((response) => {
          if (response?.data?.status === 400) {
            dispatch(fetchError(response));
            setTimeout(() => {
              dispatch(resetMessage());
            }, 6000);
          }
          if (response?.status === 200) {
            resolve();
            dispatch(fetchSuccess(response));
            setTimeout(() => {
              dispatch(resetMessage());
            }, 6000);
          } else {
            reject(new Error());
            dispatch(fetchError(response));
            setTimeout(() => {
              dispatch(resetMessage());
            }, 6000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };

  const handleSubmit = () => {
    userMetrixDelete ? setTabValue(2) : handleDeleteSubmission();
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Media Type"
        value={
          userMetrixDelete ?
            'This rule group can not be deleted as its being used in other frameworks.' :
            'Are you sure you want to delete filter rule group ?'
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleSubmit}
      />
      <OverrideRule
        dialogTitle="Delete Rule Group"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title="This Business Rule Engine has been used in the following frameworks."
        data={usageMedial?.placeResponse}
        isOverRide={false}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon ">
          <GuiTable
            title={''

            }
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `enableintegration/search/media`;
                const bodyObj = {
                  name: searchData?.mediaTypeName ? searchData?.mediaTypeName : '',
                  description: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: '',
                  orderDirection: '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }

            options={{
              toolbar: true,
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            onRowClick={(event, rowData) => {
              if (handleClose) {
                dispatch(fetchMediaType(rowData?.id));
                handleClose();
                setSelectedMediaTypeName(rowData.name);
              } else {
                setTabValue(1);
                dispatch(fetchMediaType(rowData?.id));
                setCode(rowData?.id);
                setMediaName(rowData?.name);
              }
            }}
            localization={{
              body: {editRow: {deleteText: 'Are you sure you want to delete this media type?'}},
            }}
            actions={[
              // commented for future use
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         type="button"
              //         variant="contained"
              //         className={`themeing-buttons ${classes.buttonRoot}`}
              //         color="primary"
              //         onClick={() => {
              //           dispatch(postPrintUsage({
              //             sourceCode: "",
              //             sourceType: "MEDIA TYPE",
              //           }));
              //         }}
              //       >
              //         Print Usage
              //       </Button>
              //     </>
              //   ),
              //   tooltip: "Print Usage",
              //   isFreeAction: true,
              // },
              !disableCopy && {
                icon: () => (
                  <>
                    <FileCopyOutlinedIcon className={classes.copyButtonroot} />
                  </>
                ),
                tooltip: 'Copy',
                onClick: (event, rowData) => {
                  setTabValue(1);
                  setIsCopyData(true);
                  dispatch(fetchMediaType(rowData.id));
                },
              },
              {
                icon: () => <DataUsageOutlinedIcon className={classes.copyButtonroot} />,
                tooltip: 'Usage',
                onClick: (event, rowData) => {
                  // setUsageState(true);
                  // setTabValue(2);
                  setUsage(true);
                  setDeleteUsage(false);
                  dispatch(fetchMediaTypeUsage(rowData.name));
                },
              },
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon />,
                  tooltip: 'Delete',
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                    >
                      Add Media Type
                    </Button>
                  </>
                ),
                tooltip: '',
                isFreeAction: true,
                onClick: (event) => {
                  setTabValue(1);
                },
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      color="primary"
                      onClick={() => {
                        dispatch(printMediaType({
                          name: searchData?.mediaTypeName ? searchData?.mediaTypeName : '',
                          description: searchData?.description ? searchData?.description : '',
                        }));
                      }}
                    >
                      Print
                    </Button>
                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>


              ),
            }}
          />
          {isLoading && <PageLoader/>}
          {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
          {message && <SuccessSnackbar successMsg={message} />}

        </div>
      </Grid>
    </>
  );
}
